import {InertiaApp} from '@inertiajs/inertia-vue'
import PortalVue from 'portal-vue'
import VueMeta from 'vue-meta'
import VueLazyload from 'vue-lazyload'
import Vue from 'vue'
import store from '../store'
import i18n from '../plugins/i18n';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueMobileDetection from "vue-mobile-detection";

import PhotoSwipe from 'photoswipe/dist/photoswipe.min'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.min'

import iziToast from '../shop/izitoastPlugin'
Vue.config.productionTip = false

Vue.mixin({methods: {route: window.route}})

Vue.use(InertiaApp)
Vue.use(VueMeta)
Vue.use(PortalVue)
Vue.use(VueLazyload)
Vue.use(iziToast);
Vue.use(VueMobileDetection)

library.add(faAngleDown)
Vue.component('font-awesome-icon', FontAwesomeIcon)

let app = document.getElementById('app')

const pages = require.context('./', true, /\.vue$/i)

new Vue({
    metaInfo: {
        title: 'Loading…',
        titleTemplate: '%s | Dependent de artă',
    },
    render: h => h(InertiaApp, {
        props: {
            initialPage: JSON.parse(app.dataset.page),
            resolveComponent: page => pages(`./Pages/${page}.vue`).default,
        },
    }),
    store,
    i18n
}).$mount(app)

//PSWP
window.initPhotoSwipeFromDOM = function (gallerySelector) {
    var parseThumbnailElements = function (el) {
        var all = document.querySelectorAll(gallerySelector);
        var items = [];
        for (var j = 0; j < all.length; j++) {
            var el = all[j];
            var thumbElements = el.parentNode.childNodes;
            var numNodes = thumbElements.length,
                figureEl,
                linkEl,
                size,
                item;
            for (var i = 0; i < numNodes; i++) {
                figureEl = thumbElements[i];

                if (figureEl.nodeType !== 1) {
                    continue;
                }
                linkEl = figureEl.children[0];
                size = linkEl.getAttribute('data-size').split('x');
                item = {
                    src: linkEl.getAttribute('href'),
                    w: parseInt(size[0], 10),
                    h: parseInt(size[1], 10),
                    minZoom: 3
                };
                if (figureEl.children.length > 1) {
                    item.title = figureEl.children[1].innerHTML;
                }
                if (linkEl.children.length > 0) {
                    item.msrc = linkEl.children[0].getAttribute('src');
                }

                item.el = figureEl;
                items.push(item);
            }
        }
        return items;
    };
    var closest = function closest(el, fn) {
        return el && (fn(el) ? el : closest(el.parentNode, fn));
    };
    var onThumbnailsClick = function (e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;
        var eTarget = e.target || e.srcElement;
        var clickedListItem = closest(eTarget, function (el) {
            return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
        });
        if (!clickedListItem) {
            return;
        }
        var clickedGallery = clickedListItem.parentNode,
            childNodes = document.querySelectorAll(gallerySelector),
            numChildNodes = childNodes.length,
            nodeIndex = 0,
            index;
        for (var i = 0; i < numChildNodes; i++) {
            if (childNodes[i].nodeType !== 1) {
                continue;
            }
            if (childNodes[i] === clickedListItem) {
                index = nodeIndex;
                break;
            }
            nodeIndex++;
        }
        if (index >= 0) {
            openPhotoSwipe(index, clickedGallery);
        }
        return false;
    };
    var photoswipeParseHash = function () {
        var hash = window.location.hash.substring(1),
            params = {};
        if (hash.length < 5) {
            return params;
        }
        var vars = hash.split('&');
        for (var i = 0; i < vars.length; i++) {
            if (!vars[i]) {
                continue;
            }
            var pair = vars[i].split('=');
            if (pair.length < 2) {
                continue;
            }
            params[pair[0]] = pair[1];
        }
        if (params.gid) {
            params.gid = parseInt(params.gid, 10);
        }
        return params;
    };

    var openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
        var pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options,
            items;
        items = parseThumbnailElements(galleryElement);
        options = {
            maxSpreadZoom: 5,
            galleryUID: galleryElement.getAttribute('data-pswp-uid'),
            getThumbBoundsFn: function (index) {
                var thumbnail = items[index].el.getElementsByTagName('img')[0],
                    pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                    rect = thumbnail.getBoundingClientRect();
                return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
            },
            minZoom: 3,

        };
        if (fromURL) {
            if (options.galleryPIDs) {
                for (var j = 0; j < items.length; j++) {
                    if (items[j].pid == index) {
                        options.index = j;
                        break;
                    }
                }
            } else {
                options.index = parseInt(index, 10) - 1;
            }
        } else {
            options.index = parseInt(index, 10);
        }
        if (isNaN(options.index)) {
            return;
        }
        if (disableAnimation) {
            options.showAnimationDuration = 0;
        }
        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

        var a = gallery.init();
        var ratioFix;
        gallery.listen('initialZoomIn', function () {
            var el = document.querySelectorAll('.pswp__item')[1];
            el.className += (el.className ? ' ' : '') + 'pswp__item--ratiofix';
            ratioFix = true;
        });

        gallery.listen('initialZoomInEnd', function () {
            var ratiofixTimer = window.setInterval(function () {
                var el = document.querySelectorAll('.pswp__item--ratiofix .pswp__img')[1];
                if (typeof (el) != 'undefined' && el != null) {
                    window.clearInterval(ratiofixTimer);
                    el.style.opacity = 1;
                }
            }, 10);
        });

        gallery.listen('afterChange', function () {
            if (ratioFix == true) {

                var el = document.querySelectorAll('.pswp__item--ratiofix')[0];
                var reg = new RegExp('(\\s|^)' + 'pswp__item--ratiofix' + '(\\s|$)');
                el.className = el.className.replace(reg, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
                ratioFix = false;
            }
        });
        return a;
    };
    var galleryElements = document.querySelectorAll(gallerySelector);
    for (var i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', i + 1);
        galleryElements[i].onclick = onThumbnailsClick;
    }
    var hashData = photoswipeParseHash();
    if (hashData.pid && hashData.gid) {
        openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
    }
};
